<template>
	<expand-list
		:title="$t('FEEDBACK_LIST_TITLE', { n: feedbacks.length })"
		:no-data-text="$t('FEEDBACK_LIST_NO_DATA_TEXT')"
		:maxVisibleItems="maxVisibleFeedbacks"
		:maxInlineItems="maxInlineFeedbacks"
		:color="color"
		:items="feedbacks"
		@showAll="showAll">
	
		<template v-slot="{ item: feedback }">
			<feedback-summary :item="feedback" :key="feedback.id" @select="show" @edit="saveFeedback" @remove="deleteFeedback"/>
		</template>

	</expand-list>
</template>


<script>
import ExpandList from '@/components/ExpandList';
import FeedbackSummary from '@/components/FeedbackSummary';

export default {
	name: 'feedback-list',
	components: { ExpandList, FeedbackSummary },
	props: {
		actionID: Number,
		feedbacks: Array,
		maxInlineFeedbacks: Number,
		maxVisibleFeedbacks: Number,
	},
	data() { return {
		color: '#B2DFDB',
	}},
	methods: {
		show(item) {
			this.$emit('show', item);
		},
		showAll() {
			this.$emit('showAll');
		},

		async saveFeedback(item) {
			try {
				await this.$store.dispatch('feedbacks/saveFeedback', { item });
			}
			catch(err) {
				// TODO
			}
		},

		async deleteFeedback(item) {
			try {
				await this.$store.dispatch('feedbacks/deleteFeedback', { item });
			}
			catch(err) {
				// TODO
			}
		},
	}
}
</script>

<style scoped lang="less">
	.item-list {
		border-left: 3px solid #C5E1A5;
	}
</style>